import { useState } from 'react'
import { useCopyToClipboard } from 'utils'

export function usePromotionCopy({ currentUser, teamId }) {
  const [modalState, setModalState] = useState({ isOpen: false, baseUrl: '' })
  const { copyToClipboard, isCopied } = useCopyToClipboard()
  const isOwnerOrAdmin = currentUser?.teamRole === 'owner' || currentUser?.teamRole === 'admin'
  const inviteCode = currentUser?.inviteCode || null

  const handleCopyClick = (baseUrl) => {
    if (isOwnerOrAdmin) {
      setModalState({ isOpen: true, baseUrl })
    } else {
      copyToClipboard(baseUrl)
    }
  }

  const closeModal = () => setModalState({ isOpen: false, baseUrl: '' })

  return { handleCopyClick, modalState, closeModal, isCopied, isOwnerOrAdmin, inviteCode }
}
